<ng-template [sbmodal]="'inventorySelectionModal'">
  <sb-custom-modal [templateId]="'inventorySelectionModal'">
    <div slot="body">
      <sb-page-inventory-wrapper [isInModalContext]="true"></sb-page-inventory-wrapper>
    </div>
  </sb-custom-modal>
</ng-template>

<div class="row">
  <div class="col-12">
    <table class="table content-table" style="padding: 1rem;border-radius: 5px;">
      <tbody>
      <tr>
        <td>
          <h5 class="font-weight-bold">{{cull.staticElements.length}} {{'lang.globals.screens' | translate}}</h5>
          <p>{{'lang.globals.staticScreens' | translate}}</p>
        </td>
        <td></td>
        <td class="text-end">
          <div class="form-group my-0 mr-3 d-inline-block">
            <div class="form-check form-switch d-table">
              <input [ngModel]="inverted" [disabled]="disabled"
                     (ngModelChange)="toggleInverted()" type="checkbox" role="switch" class="form-check-input"
                     id="Inverted">
              <label class="form-check-label"
                     for="Inverted">{{'lang.globals.blacklist' | translate}}</label>
            </div>
            <span *ngIf="!disabled"
                  class="form-text text-muted">{{'lang.globals.blacklistDescription.devices' | translate}}</span>
          </div>
          <button *ngIf="cull && cull.staticElements.length > 0" (click)="openDetails()"
                  class="btn btn-secondary" [ngClass]="{'btn-hover-secondary' : collapsed === false}">
            <sb-icon *ngIf="!collapsed" class="icon-in-btn" icon="chevronDown"></sb-icon>
            <sb-icon *ngIf="collapsed" class="icon-in-btn" icon="chevronUp"></sb-icon>
          </button>
          <button *ngIf="!disabled" (click)="addScreenRow()" class="btn btn-primary ml-1">
            <sb-icon icon="plus"></sb-icon>
            {{'lang.devices.addScreens' | translate}}
          </button>
        </td>
      </tr>
      <tr *ngIf="collapsed === false" class="row-subtable">
        <td colspan="100">
          <div>
            <ng-scrollbar style="height: 300px;" class="w-100">
              <table class="table content-table" style="padding-bottom: 2rem;">
                <thead>
                <tr>
                  <th>{{'lang.globals.channel' | translate}} / {{'lang.globals.screen' | translate}}</th>
                  <th>{{'lang.globals.device' | translate}}</th>
                  <th>{{'lang.globals.resolution' | translate}}</th>
                  <th>{{'lang.globals.image' | translate}}</th>
                  <th>{{'lang.globals.video' | translate}}</th>
                  <th>{{'lang.globals.html' | translate}}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody class="w-100">
                <tr *ngFor="let ele of this.cull.staticElements; index as i" class="w-100">
                  <td>
                    <sb-comp-image-name-wrapper [image]="ele?.marker?.channel?.logo?.url">
                      <span firstLine>{{ele?.marker?.channel?.name}}</span>
                      <span secondLine>{{ele?.name}}</span>
                    </sb-comp-image-name-wrapper>
                  </td>
                  <td>
                    <span class="font-weight-bold d-block">{{ele?.device?.id}}</span>
                    <span class="text-muted font-weight-bold d-block">{{ele?.device?.name}}</span>
                  </td>
                  <td>{{ele?.marker?.resolution?.id}}</td>
                  <td>
                    <sb-icon *ngIf="ele?.marker?.image" class="green" icon="success"></sb-icon>
                    <sb-icon *ngIf="!ele?.marker?.image" class="red" icon="error"></sb-icon>
                  </td>
                  <td>
                    <sb-icon *ngIf="ele?.marker?.video" class="green" icon="success"></sb-icon>
                    <sb-icon *ngIf="!ele?.marker?.video" class="red" icon="error"></sb-icon>
                  </td>
                  <td>
                    <sb-icon *ngIf="ele?.marker?.html" class="green" icon="success"></sb-icon>
                    <sb-icon *ngIf="!ele?.marker?.html" class="red" icon="error"></sb-icon>
                  </td>
                  <td class="text-end">
                    <button *ngIf="!disabled" [disabled]="false" (click)="removeScreen(i)" class="btn btn-danger">
                      <sb-icon icon="trash"></sb-icon>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </ng-scrollbar>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <ng-container *ngIf="easyMode === false">
      <sb-filter-definition [disabled]="disabled" [preselectType]="true" [isInModalContext]="false" *ngIf="cull"
                            [(cull)]="cull" (cullChange)="emitChange($event)">
      </sb-filter-definition>
    </ng-container>
    <ng-container *ngIf="(easyMode || easyMode === undefined) && !loading">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </ng-container>
    <!-- <div [@slideInOut] *ngFor="let row of easyModeRows; let i = index; first as isFirst; last as isLast" class="d-flex justify-content-between align-items-center border-dashed-bottom" style="padding-bottom: 1rem;
  margin-bottom: 1rem;">
       <select [disabled]="disabled" [(ngModel)]="row.field" (ngModelChange)="rowChanged(row)" [ngModelOptions]="{standalone: true}" class="form-control">
         <option *ngFor="let option of fieldValues" [value]="option.id">{{option.name}}</option>
       </select>
       <span class="mx-3">=</span>
       <input [disabled]="disabled" [(ngModel)]="row.value" (ngModelChange)="rowChanged(row)" [ngModelOptions]="{standalone: true}" class="form-control">
       <sb-button *ngIf="!disabled" [disabled]="isFirst && isLast" (onSubmit)="removeRow(i)" classes="btn-primary mr-0 ml-2"><sb-icon icon="trash"></sb-icon> </sb-button>
     </div>
     <div *ngIf="!disabled" class="d-flex justify-content-center">
       <sb-button (onSubmit)="addRow()" classes="btn-primary m-0">+ {{'lang.culls.addRow' | translate}}</sb-button>
     </div> -->
    <!--<div *ngFor="let screen of screens; let i = index; first as isFirst; last as isLast"
         class="d-flex justify-content-between align-items-center border-dashed-bottom" style="padding-bottom: 1rem;
 margin-bottom: 1rem;">
      <i>{{screen?.name}}</i>
      <sb-button *ngIf="!disabled" [disabled]="false" (onSubmit)="removeScreen(i)" classes="btn-primary mr-0 ml-2">
        <sb-icon icon="trash"></sb-icon>
      </sb-button>
    </div>
    <div *ngIf="!disabled" class="d-flex justify-content-center">
      <sb-button (onSubmit)="addScreenRow()" classes="btn-primary m-0">
        + {{'lang.devices.addDevice' | translate}}</sb-button>
    </div>-->
  </div>
</div>

